/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_StockDetailDto } from '../models/PagedResultDto_StockDetailDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_CurrentMarketValue } from '../models/Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_CurrentMarketValue';
import type { Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_LatestMarketValue } from '../models/Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_LatestMarketValue';
import type { Wealthlane_FinanceIntegrationService_Dtos_StockDto_ExportResponseDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_StockDto_ExportResponseDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StockService {

    /**
     * @param fromDate 
     * @param toDate 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockStocks(
fromDate?: string,
toDate?: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/stocks',
            query: {
                'FromDate': fromDate,
                'ToDate': toDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromDate 
     * @param toDate 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockStocksForCustomer(
fromDate?: string,
toDate?: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/stocks-for-customer',
            query: {
                'FromDate': fromDate,
                'ToDate': toDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param ticker 
     * @param isOtcbq 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockCurrentStockTest(
ticker?: string,
isOtcbq?: boolean,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/current-stock-test',
            query: {
                'ticker': ticker,
                'isOTCBQ': isOtcbq,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockFiveYearStockData(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/five-year-stock-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockThreeYearStockData(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/three-year-stock-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockOneYearStockData(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/one-year-stock-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockOneMonthStockData(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/one-month-stock-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockYearToDateStockData(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/year-to-date-stock-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param ticker 
     * @param isOtcbq 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockClosingStockData(
ticker?: string,
isOtcbq?: boolean,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/closing-stock-data',
            query: {
                'Ticker': ticker,
                'isOTCBQ': isOtcbq,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockMarketStatus(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/market-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param symbol 
     * @param isOtcbq 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockLatestBars(
symbol?: string,
isOtcbq?: boolean,
): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/latest-bars',
            query: {
                'symbol': symbol,
                'isOTCBQ': isOtcbq,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_CurrentMarketValue OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockCurrentMarketQuote(): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_CurrentMarketValue> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/current-market-quote',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppStockCheckCurrentUser(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/stock/check-current-user',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param symbol 
     * @param from 
     * @param to 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockOTCHistory(
symbol?: string,
from?: string,
to?: string,
): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/o-tCHistory',
            query: {
                'symbol': symbol,
                'from': from,
                'to': to,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param ticker 
     * @param cacheKey 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppStockFetchLatestBarFromYahoo(
ticker?: string,
cacheKey?: string,
): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/stock/fetch-latest-bar-from-yahoo',
            query: {
                'ticker': ticker,
                'cacheKey': cacheKey,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromDate 
     * @param toDate 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_StockDetailDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockHistoricalStockPrice(
fromDate?: string,
toDate?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_StockDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/historical-stock-price',
            query: {
                'FromDate': fromDate,
                'ToDate': toDate,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromDate 
     * @param toDate 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_StockDto_ExportResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppStockExportHistoricalStockPrice(
fromDate?: string,
toDate?: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_StockDto_ExportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/stock/export-historical-stock-price',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param symbol 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppStockClearCachedPrice(
symbol?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/stock/clear-cached-price',
            query: {
                'symbol': symbol,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param symbol 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_LatestMarketValue OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppStockCurrentMarketPrice(
symbol?: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_AlpacaDto_LatestMarketValue> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/stock/current-market-price',
            query: {
                'symbol': symbol,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
